import React, { useState } from 'react';

import LearnerConversation from 'components/Practice/Learner/LearnerConversation';
import request from 'utils/request_ajax';

function ConversationLearner({ data, meta }) {
  const [lessonConversationComplete, setLessonConversationComplete] = useState(
    data.givenAnswer === '_conversation_completed_',
  );
  const [conversationSaveError, setConversationSaveError] = useState(false);

  const saveAttempt = async selectedResponses => {
    if (meta.previewing) {
      setLessonConversationComplete(true);
    } else {
      const selectedResponseIds = selectedResponses.map(
        response => response.question_interaction_response_id,
      );

      try {
        await request.postJSON(meta.saveUrl, {
          question_id: data.questionId,
          response_attempts: selectedResponseIds,
        });
        setLessonConversationComplete(true);
        setConversationSaveError(false);
      } catch (error) {
        console.error(error);
        setLessonConversationComplete(false);
        setConversationSaveError(true);
      }
    }
  };

  const tryAgain = () => {
    request.post(meta.saveUrl, {
      question_id: data.questionId,
      retry_conversation: true,
    });
  };

  return (
    <LearnerConversation
      title={data.conversationTitle}
      prompt={data.subject}
      conversation={data}
      saveAttempt={saveAttempt}
      saveError={conversationSaveError}
      tryAgain={tryAgain}
      saving={false}
      isPreviewing={meta.previewing}
      isLessonFinished={meta.finished}
      lessonConversationComplete={lessonConversationComplete}
    />
  );
}

export default props => <ConversationLearner {...props} />;
